import { Box, Typography, SxProps, Theme } from "@mui/material";
import { SvgIconComponent } from "@mui/icons-material";

type Props = {
  icon: SvgIconComponent;
  message: string;
};

export function EmptyMessage({ icon: Icon, message }: Props) {
  return (
    <Box sx={styles.container}>
      <Icon sx={styles.icon} />
      <Typography variant="subtitle1" color="secondary">
        {message}
      </Typography>
    </Box>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 20px",
    width: "100%"
  },
  icon: {
    fontSize: "64px",
    color: "#c7c8c9",
    marginBottom: "12px"
  }
};
